export const AppColors = {
  background: "#f5f1e5",
  sand: "#C6BCA9",
  lemon: "#F2E48D",
};
